import * as v from "valibot";

import { rpcContract } from "../rpc";

export const getBrandRpcContract = rpcContract({
  name: "getBrand",
  paramsSchema: v.object({
    brandId: v.string(),
  }),
  resultSchema: v.object({
    id: v.string(),
    name: v.string(),
    thumbnail: v.nullable(v.string()),
    hasMetaPixel: v.boolean(),
    metaPixelId: v.string(),
    fileId: v.string(),
  }),
});

export type GetBrandParams = v.InferOutput<(typeof getBrandRpcContract)["paramsSchema"]>;
export type GetBrandResult = v.InferOutput<(typeof getBrandRpcContract)["resultSchema"]>;
